import { Component, DOCUMENT, LOCALE_ID, inject } from '@angular/core';

import { VismaOAuthService } from '#core/services/visma-oauth.service';

@Component({
  selector: 'di-root',
  templateUrl: './app.component.html',
  standalone: false,
  host: {
    class: 'tw:block tw:h-full',
  },
})
export class AppComponent {
  private readonly locale = inject(LOCALE_ID);
  private readonly document = inject(DOCUMENT);
  private readonly oauthService = inject(VismaOAuthService);

  // Computed signal for authentication state
  public readonly isAuthenticatingSignal = this.oauthService.isAuthenticatingSignal;

  constructor() {
    // Needed to make sure web-components pick up correct locale
    this.document.documentElement.lang = this.locale;
  }
}
